import Styled from 'styled-components'

export const Content = Styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  .bg-gray {
    background-color: #FAFBFF;
  }
`
export const Footer = Styled.div`
  position: absolute;
  bottom: 0;
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  max-width: 480px;
  width: 100%;
  left: 50%;
  transform: translateX(-50%);

  .btn-default-wl,
  .btn-secondary-wl {
    width: 100%;
    padding: 14px 24px;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 700;
    line-height: 1.5;
    text-transform: uppercase;
    border: 1px solid transparent;
  }

  .btn-secondary-wl {
    background: #FFFFFF;
    color: #595959;
    border-color: #595959;
  }
`

export const Img = Styled.img`
  width: 139.07px;
  height: 104.28px;
  margin-bottom: 10px;
`

export const OrderNumber = Styled.span`
  position: relative;
  left: 30%
`

export const SubLabel = Styled.p`
  text-align: center;
`

export const Label = Styled.p`
  font-weight: 400;
  font-size: 24px;
  line-height: 30px;
  text-align: center;
  color: ${props => props.theme.primary};
`